import { handle } from 'redux-pack';
import { SMALL } from 'constants/radii';
import {
  SEARCH,
  SET_ERROR_MESSAGE,
  SET_SEARCH_ACTIVE,
  UPDATE_RADIUS,
  UPDATE_ZIPCODE,
} from './types';

const initialState = {
  zipcode: {
    value: '',
    isValid: false,
  },
  radius: SMALL,
  errorMessage: null,
  isActive: false,
  isLoading: false,
};

export function searchReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_SEARCH_ACTIVE:
      return {
        ...state,
        isActive: payload,
        isLoading: payload ? state.isLoading : false,
      };
    case SEARCH:
      return handle(state, action, {
        start: prevState => ({
          ...prevState,
          isLoading: true,
        }),
        success: prevState => ({
          ...prevState,
          isActive: true,
          isLoading: false,
        }),
      });
    case UPDATE_ZIPCODE: {
      const { value, isValid } = payload;
      return {
        ...state,
        zipcode: {
          isValid,
          value,
        },
        errorMessage: null,
      };
    }
    case UPDATE_RADIUS:
      return {
        ...state,
        radius: payload,
        errorMessage: null,
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: payload,
      };
    default:
      return state;
  }
}
